import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { ExternalLinkButton, Text } from '../../..'
import { selectHomeImprovementBudget } from '../../../../store/selectors/home/equity'
import { Heading, ProConList, Pro, Con } from '../../../shared/Gem/GemDetail'
import { CUSTOMER_MESSAGES } from '../../../../constants/customerMessages'

const HomeImprovement = props => (
  <div>
    <Heading>
      <FormattedMessage
        id='Homeowner.equity.homeImprovementHeading'
        defaultMessage='Using equity is a great way to let your home pay for its own improvements. However, proceed with caution and consult a loan officer or real estate expert as the return on investment varies for different projects.'
      />
    </Heading>

    <ProConList>
      <Pro>
        <FormattedMessage
          id='Homeowner.equity.homeImprovementFour'
          defaultMessage='Equity used for home improvements is still tax-deductible in many cases. (Always consult a professional tax advisor)'
        />
      </Pro>
      <Pro>
        <FormattedMessage
          id='Homeowner.equity.homeImprovementOne'
          defaultMessage='The highest value improvements are curb appeal projects, minor kitchen remodels, and universal bathroom remodels'
        />
      </Pro>
      <Con>
        <FormattedMessage
          id='Homeowner.equity.homeImprovementTwo'
          defaultMessage='The lowest value improvements are swimming pools, backyard patios, and gourmet kitchens'
        />
      </Con>
      <Con>
        <FormattedMessage
          id='Homeowner.equity.homeImprovementThree'
          defaultMessage='Average amount recouped is 56¢ on the dollar {source}'
          values={{
            source: (
              <Text element='span' nowrap variant='neutralCool' variantCount='900'>
                (
                <ExternalLinkButton minimal href='https://www.remodeling.hw.net/cost-vs-value/2020/'>
                  <FormattedMessage id='Homeowner.equity.homeImprovementSource' defaultMessage='source' />
                </ExternalLinkButton>
                )
              </Text>
            )
          }}
        />
      </Con>
      <Pro>
        <FormattedMessage
          id='Homeowner.equity.homeImprovementFive'
          defaultMessage='Improvements towards a rentable space will recoup your investment quicker'
        />
      </Pro>
    </ProConList>
  </div>
)

export default {
  GemContainer: connect(state => ({
    qaTag: 'homeImprovementGem',
    amount: selectHomeImprovementBudget(state)
  })),
  Detail: HomeImprovement,
  topic: CUSTOMER_MESSAGES.HOME_IMPROVEMENTS.topic,
  topicKey: CUSTOMER_MESSAGES.HOME_IMPROVEMENTS.topicKey,
  question: CUSTOMER_MESSAGES.HOME_IMPROVEMENTS.message
}
